export type PrizmStepperStatus = 'success' | 'warning' | 'danger' | 'default';
